import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost, apiPatch } from 'api-service';
import translation from 'translation';
import { toast } from 'lib';
import { magicNumbers } from 'utils';
import { prepareParams } from './alarmHelpers';
import { alarmAdapter } from './alarm.adapter';
const { t } = translation;

export const getChannels = createAsyncThunk(
  'alarmReducer/getChannels',
  async (_, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/alarm/receivers');

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createAlarm = createAsyncThunk(
  'alarmReducer/createAlarm',
  async (payload, thunkAPI) => {
    const alarmState = thunkAPI.getState().alarmReducer;
    const params = prepareParams(alarmState, payload);

    try {
      const response = await apiPost('/search/api/v1/alarm/alarms', params);

      toast({
        title: t('alarm:success.addAlarm.title'),
        description: t('alarm:success.addAlarm.description', {
          type: t('alarm:saveAlarm'),
        }),
        type: 'success',
      });

      return response;
    } catch (error) {
      toast({
        title: t('alarm:error.saveOrEditAlarm.title', {
          type: t('alarm:saveAlarm'),
        }),
        description: t('alarm:error.saveOrEditAlarm.description', {
          type: t('alarm:saveAlarm'),
        }),
        type: 'error',
      });

      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editAlarm = createAsyncThunk(
  'alarmReducer/editAlarm',
  async (payload, thunkAPI) => {
    const alarmState = thunkAPI.getState().alarmReducer;
    const params = prepareParams(alarmState, payload);

    try {
      const response = await apiPatch(
        `/search/api/v1/alarm/alarms/${alarmState.alarmId}`,
        params
      );

      toast({
        title: t('alarm:success.addAlarm.title'),
        description: t('alarm:success.addAlarm.description', {
          type: t('alarm:editAlarm'),
        }),
        type: 'success',
      });

      return response;
    } catch (error) {
      toast({
        title: t('alarm:error.saveOrEditAlarm.title', {
          type: t('alarm:editAlarm'),
        }),
        description: t('alarm:error.saveOrEditAlarm.description', {
          type: t('alarm:editAlarm'),
        }),
        type: 'error',
      });

      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAlarm = createAsyncThunk(
  'alarmReducer/getAlarm',
  async (alarmId, thunkAPI) => {
    try {
      const response = await apiGet(`/search/api/v1/alarm/alarms/${alarmId}`);

      return alarmAdapter(response?.data?.result?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchApps = createAsyncThunk(
  'alarmReducer/fetchApps',
  async (_, thunkAPI) => {
    try {
      const response = await apiGet(
        '/search/api/v1/brand-identity/applications/allowed'
      );

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchOtherApps = createAsyncThunk(
  'alarmReducer/fetchOtherApps',
  async ({ searchQuery } = {}, thunkAPI) => {
    try {
      const response = await apiGet(
        '/search/api/v1/brand-identity/applications/others',
        {
          q: searchQuery,
          count: magicNumbers.FILTER_SEARCH_RESULT_COUNT,
          page: 1,
        }
      );

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addAlarmChannel = createAsyncThunk(
  'alarmReducer/addAlarmChannel',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost('/search/api/v1/alarm/receivers', params);

      toast({
        title: t('alarm:success.addNewChannel.title'),
        description: t('alarm:success.addNewChannel.description'),
      });

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const changeAlarmStatus = createAsyncThunk(
  'alarmReducer/changeAlarmStatus',
  async ({ id, status }, thunkAPI) => {
    try {
      await apiPatch(`/search/api/v1/alarm/alarms/${id}/status`, {
        is_active: status,
      });

      if (status)
        toast({
          title: t('common:success'),
          description: t('alarm:alarmWasActivatedSuccessfully'),
          type: 'success',
        });
      else
        toast({
          title: t('common:success'),
          description: t('alarm:AlarmSuccessfullyDisabled'),
          type: 'success',
        });

      return true;
    } catch (error) {
      toast({
        title: t('common:error'),
        description: error?.response?.data?.errors?.data?.message,
        type: 'error',
      });

      return thunkAPI.rejectWithValue(error);
    }
  }
);
